<template lang="html">
  <div class="licence-content">
    <div class="title">{{ config.title }}</div>
    <p class="desc">{{ config.desc }}</p>
    <div v-if="showPic" class="pics-list">
      <Empty v-if="!imgUrl" no-data="暂无证书" />
      <img v-else :src="imgUrl" class="pics-list-img">
    </div>
    <div v-else>
      <div class="verify-code-block">
        <input v-model="inputCode" placeholder="请输入验证码查看证件信息">
        <div class="verify-code pf-medium" @click="generateCode">{{ code }}</div>
      </div>
      <button @click="confirm">确认</button>
    </div>
  </div>
</template>

<script>
import { http } from '@utils/interceptor'
import { viewImage } from '@utils/image'
import { Toast } from 'vant'
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      config: {},
      code: '',
      showPic: false,
      inputCode: '',
      imgUrl: '',
      businessId: '',
    }
  },
  computed: {
    ...mapState('shopHome', {
      shopDetail: (state) => state.shopDetail,
    }),
  },
  async created() {
    this.$setTitle('商家营业执照信息')
    this.businessId = this.$route.query.businessId
    this.getShopDetailAction({ businessId: this.businessId })
    const res = await http.get('https://cms.cekid.com/publish/999/promotions.json')
    // console.log(res)
    if (res.code === 0) {
      this.config = res.data.businessAptitudeInfo
    }
    this.generateCode()
    // this.$$loading(false)
  },
  methods: {
    ...mapActions('shopHome', ['getShopDetailAction']),
    getShopDetail() {
      this.$store
    },
    confirm() {
      if (this.inputCode) {
        if (this.inputCode.toLocaleLowerCase() === this.code.toLocaleLowerCase()) {
          // console.log('ready');
          this.getPic()
        } else {
          Toast('请输入正确的验证码')
          this.generateCode()
        }
      }
    },
    async getPic() {
      if (this.shopDetail && this.shopDetail.bizLicense) {
        this.showPic = true
        this.imgUrl = this.shopDetail.bizLicense
      } else {
        const res = await http.get(`//api.czj100.com/school/getBusinessAptitudeInfo?businessId=${this.businessId}`)
        // console.log(res, json)
        if (+res.errno === 0) {
          this.showPic = true
          this.imgUrl = res.data && res.data.businessLicenceImgUrl ? viewImage(res.data.businessLicenceImgUrl) : ''
        } else {
          Toast(res.errmsg)
        }
      }
    },
    generateCode() {
      const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      this.code = this.captchaText({ charPreset: str })
    },
    randomInt(min, max) {
      return Math.round(min + Math.random() * (max - min))
    },
    stripCharsFromString(string, chars) {
      return string.split('').filter((char) => chars.indexOf(char) === -1)
    },
    /*eslint-disable*/
    captchaText(options) {
      options = options || {}
      const size = options.size || 4
      const ignoreChars = options.ignoreChars || ''
      let i = -1
      let out = ''
      let chars = options.charPreset

      chars = this.stripCharsFromString(chars, ignoreChars)
      const len = chars.length - 1
      while (++i < size) {
        out += chars[this.randomInt(0, len)]
      }
      return out
    },
  },
}
</script>

<style lang="scss" scoped>
// @import '../../assets/css/mixin';

.licence-content {
  background-color: #fff;
  min-height: 100vh;
  padding: 50px 30px;
}

.title {
  font-size: 32px;
  color: #121212;
  text-align: center;
  line-height: 100px;
}

.desc {
  font-size: 30px;
  color: #121212;
  text-align: center;
  line-height: 50px;
}

.pics-list-img {
  margin-top: 30px;
}

.verify-code-block {
  display: flex;
  align-items: center;
  padding-top: 40px;

  .verify-code {
    background-color: #ddd;
    width: 160px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-size: 32px;
  }
  ::-webkit-input-placeholder {
    color: #999 !important;
    font-size: 28px;
  }

  input {
    flex: 1;
    margin-right: 50px;
    height: 60px;
    line-height: 60px;
    border: 1px solid #ddd;
    padding-left: 10px;
    font-size: 28px;
  }
}
.empty {
  text-align: center;
  padding: 50px 0;
}

button {
  margin-top: 40px;
  width: 100%;
  height: 100px;
  background-color: #ff6ea2;
  text-align: center;
  line-height: 100px;
  color: #fff;
  font-size: 36px;
}
</style>
